// export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:9099';
export const API_URL = process.env.REACT_APP_API_URL || 'https://api-dev.pyramid-poc.phinxlab.com';
